import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd, RouterModule } from "@angular/router";
import { filter } from "rxjs";

@Component({
  selector: "app-breadcrumbs",
  standalone: true,
  template: `
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        @for(breadcrumb of breadcrumbs; track $index; let last=$last) { @if(breadcrumb.label) {
        <li class="breadcrumb-item" [ngClass]="{ active: last }">
          @if(!last) {
          <a [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
          } @else {
          <span [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</span>
          }
        </li>
        } }
      </ol>
    </nav>
  `,
  styleUrls: ["./app-breadcrumbs.component.scss"],
  imports: [RouterModule, CommonModule],
})
export class AppBreadcrumbsComponent {
  breadcrumbs: Array<any> = [];

  constructor(private router: Router, private route: ActivatedRoute) {
    this.router.events.pipe(filter((event: any) => event instanceof NavigationEnd)).subscribe((_event) => {
      this.breadcrumbs = [];
      let currentRoute = this.route.root;
      let url = "";
      while (currentRoute.children.length > 0) {
        const childrenRoutes = currentRoute.children;
        childrenRoutes.forEach((route) => {
          if (route.outlet === "primary") {
            const routeSnapshot = route.snapshot;
            if (route.snapshot.data["url"]) {
              url += "/" + route.snapshot.data["url"] + "/";
            } else {
              url += "/" + routeSnapshot.url.map((segment) => segment.path).join("/");
            }
            if (route.snapshot.data["title"]) {
              this.breadcrumbs.push({
                label: route.snapshot.data["title"],
                url,
              });
            }
            currentRoute = route;
          }
        });
      }
    });
  }
}
